import type { FC } from 'react'
import styled from 'styled-components'

import { ButtonsContainer } from '@/components/IdentityCard/IdentityCard'
import LandlordPropertyReference from '@/components/Landlord/LandlordPropertyReference'
import SmallPill from '@/components/SmallPill'
import type { Address, Application } from '@/types/Activity'
import type { AddressLandlordReference } from '@/types/Landlord'
import type { OutcomeStatus } from '@/types/Outcome'
import { isFinalOutcome } from '@/utils/outcome'

import AddLandlordReferee from './Add'
import RemoveLandlordReference from './Remove'
import Title from './Title'

const PillWrapper = styled.div`
  margin-top: 10px;
`

const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content;
  gap: 20px;
  align-items: end;
`

interface Props {
  customerId: string
  subjectId: string
  address: Address
  reference?: AddressLandlordReference
  application: Application
  navigateToLandlordReferee: (id: string) => void
  residentialOutcomeStatus?: OutcomeStatus
  isRestrictedReference?: boolean
}

const LandlordReference: FC<Props> = ({
  customerId,
  subjectId,
  address,
  application,
  reference,
  navigateToLandlordReferee,
  residentialOutcomeStatus,
  isRestrictedReference,
}) => (
  <div>
    {reference ? (
      <>
        <HeaderContainer>
          <Title />
          {!isRestrictedReference && !isFinalOutcome(residentialOutcomeStatus) && (
            <ButtonsContainer>
              <RemoveLandlordReference
                customerId={application.customerId}
                subjectId={application.subjectId}
              />
            </ButtonsContainer>
          )}
        </HeaderContainer>
        <PillWrapper>
          <SmallPill onClick={() => navigateToLandlordReferee(reference.subjectId)}>
            View landlord reference
          </SmallPill>
        </PillWrapper>
        <LandlordPropertyReference
          application={application}
          reference={reference}
          subjectId={application.subjectId}
          address={address}
        />
      </>
    ) : (
      <>
        <Title />
        <p>This address does not have a landlord reference.</p>
        {!isRestrictedReference && (
          <AddLandlordReferee customerId={customerId} subjectId={subjectId} />
        )}
      </>
    )}
  </div>
)

export default LandlordReference
